import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import background3 from '../assets/background3.png';

class Forms extends Component {
  render() {
    const pageStyle = {
      backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${background3})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
    };

    const contentStyle = {
      maxWidth: 900,
      margin: '0 auto',
      padding: '32px 16px 48px',
      textAlign: 'center',
      color: '#111',
      lineHeight: 1.6,
    };

    const flickerLinkStyle = {
      color: 'red',
      fontWeight: 'bold',
      textDecoration: 'none',
      animation: 'flicker 1s infinite',
      display: 'inline-block',
    };

    return (
      <div className="App" style={pageStyle}>
        <style>
          {`
            @keyframes flicker {
              0%   { opacity: 1; }
              25%  { opacity: 0.3; }
              50%  { opacity: 1; }
              75%  { opacity: 0.4; }
              100% { opacity: 1; }
            }
          `}
        </style>

        <div style={contentStyle}>
          <div style={{ textAlign: 'left' }}>
            <img className="logo" src={logo} alt="Thai-Aikikai logo" />
          </div>

          <br />
          <br />

          <div className="registration-form">
            <a
              href="https://docs.google.com/forms/d/1dbk45-xe_7C_PiZdBlDJC3f18_mZ7AUbiE6uAA0yxpM"
              target="_blank"
              rel="noopener noreferrer"
              className="external-btn"
              style={flickerLinkStyle}
            >
              🚀 Link to New Member&apos;s Registration Form
            </a>

            <br />
            <br />

            <div className="examination-form">
              <a
                href="https://docs.google.com/forms/d/1nN8t5ittuWprgULC67yx-dUzTQbH5KgRIxazKxeWsLE"
                target="_blank"
                rel="noopener noreferrer"
                className="external-btn"
                style={flickerLinkStyle}
              >
                🚀 Link to Examination Form
              </a>
            </div>

            <br />
            <br />
            <div className="Affiliated-Dojos-Members">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfxTj7KF9MfaIuRLz8BV2H3Kmy022Bu_q-EcnydxxK7Pbuk1g/viewform?usp=dialog"
                target="_blank"
                rel="noopener noreferrer"
                className="external-btn"
                style={flickerLinkStyle}
              >
                🚀 Link to Affiliated Dojos Members Registration Form
              </a>
            </div>

            <br />
            <br />
            <div className="qrs-folder">
              <a
                href="https://drive.google.com/drive/folders/10Cjcv928lrWsXL5QNxytAHGrSUpcCA2K"
                target="_blank"
                rel="noopener noreferrer"
                className="external-btn"
                style={flickerLinkStyle}
              >
                🚀 Link to QRs Folder
              </a>
            </div>

            <br />
            <br />

            <div>Powered by</div>
            <img
              className="logo2"
              src={logo2}
              alt="New Wave Consulting Group"
              style={{ height: 50 }}
            />
            <div>New Wave Consulting Group</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Forms;
